/**
 * How often a live-runs view polls the short-lived run store while its listen
 * window is open. Shared by every codegen domain (shipping providers, Agentic
 * Logic rules).
 */
export const LIVE_RUNS_POLL_INTERVAL_MS = 3_000;

/** How often the listen-window countdown re-renders while listening. */
export const LIVE_RUNS_COUNTDOWN_TICK_MS = 1_000;
